/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrendPoint } from './TrendPoint';
import {
    TrendPointFromJSON,
    TrendPointFromJSONTyped,
    TrendPointToJSON,
    TrendPointToJSONTyped,
} from './TrendPoint';

/**
 * 
 * @export
 * @interface ProgramHealthHeadline
 */
export interface ProgramHealthHeadline {
    /**
     * 
     * @type {number}
     * @memberof ProgramHealthHeadline
     */
    programHealthScore?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramHealthHeadline
     */
    programHealthScore30dAgo?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramHealthHeadline
     */
    delta30d?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramHealthHeadline
     */
    topLevelParentCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramHealthHeadline
     */
    contributingParentCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramHealthHeadline
     */
    equalWeighting?: boolean;
    /**
     * 
     * @type {Array<TrendPoint>}
     * @memberof ProgramHealthHeadline
     */
    trendPoints?: Array<TrendPoint>;
}

/**
 * Check if a given object implements the ProgramHealthHeadline interface.
 */
export function instanceOfProgramHealthHeadline(value: object): value is ProgramHealthHeadline {
    return true;
}

export function ProgramHealthHeadlineFromJSON(json: any): ProgramHealthHeadline {
    return ProgramHealthHeadlineFromJSONTyped(json, false);
}

export function ProgramHealthHeadlineFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramHealthHeadline {
    if (json == null) {
        return json;
    }
    return {
        
        'programHealthScore': json['programHealthScore'] == null ? undefined : json['programHealthScore'],
        'programHealthScore30dAgo': json['programHealthScore30dAgo'] == null ? undefined : json['programHealthScore30dAgo'],
        'delta30d': json['delta30d'] == null ? undefined : json['delta30d'],
        'topLevelParentCount': json['topLevelParentCount'] == null ? undefined : json['topLevelParentCount'],
        'contributingParentCount': json['contributingParentCount'] == null ? undefined : json['contributingParentCount'],
        'equalWeighting': json['equalWeighting'] == null ? undefined : json['equalWeighting'],
        'trendPoints': json['trendPoints'] == null ? undefined : ((json['trendPoints'] as Array<any>).map(TrendPointFromJSON)),
    };
}

export function ProgramHealthHeadlineToJSON(json: any): ProgramHealthHeadline {
    return ProgramHealthHeadlineToJSONTyped(json, false);
}

export function ProgramHealthHeadlineToJSONTyped(value?: ProgramHealthHeadline | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'programHealthScore': value['programHealthScore'],
        'programHealthScore30dAgo': value['programHealthScore30dAgo'],
        'delta30d': value['delta30d'],
        'topLevelParentCount': value['topLevelParentCount'],
        'contributingParentCount': value['contributingParentCount'],
        'equalWeighting': value['equalWeighting'],
        'trendPoints': value['trendPoints'] == null ? undefined : ((value['trendPoints'] as Array<any>).map(TrendPointToJSON)),
    };
}

